import resume from '../assets/pdf/Umesh_Resume.pdf'
import umesh from "../assets/jpg/umesh.png"

export const headerData = {
    name: 'Umesh Kumar Mishra',
    title: "Software Engineer",
    desciption:"Software engineer focused on building scalable web and mobile applications with React, React Native, Next.js, and modern full stack technologies. Passionate about AI-driven products, intelligent user experiences, and creating high-performance digital solutions for modern businesses.",
    image: umesh,
    resumePdf: resume
}